import Http from '@/services/http';
import { Map } from 'sigma-mappings';
import editInstallationsFieldsDefinitions
  from '@/domain/data/installation/editInstallationsFieldsDefinitions';
import translate from '@/services/translate';

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA029: (data) => {
        const returnedField = editInstallationsFieldsDefinitions[data.field];
        if (!returnedField) return null;
        return {
          FaixaInicial: returnedField.min,
          FaixaFinal: returnedField.max,
          NomeDoCampo: translate(returnedField.label),
        };
      },
    },
  },
};

const urls = {
  base: '/instalacao/mapa',
  save: installationId => `/instalacao/${installationId}/mapa`,
};

export default {
  getInstallations() {
    const http = new Http();
    return http.get(urls.base)
      .then(({ data }) => data.map(item => new Map(item)));
  },

  saveInstallationPosition({ id, latitude, longitude }) {
    const http = new Http(error);
    return http.put(urls.save(id), { latitude, longitude });
  },
};
